<template>
  <!-- edit profile dialog -->
  <v-dialog
    v-model="isAddClassDialogOpen"
    max-width="650px"
    @click:outside="$emit('update:is-add-class-dialog-open',false)"
  >
    <v-card class="user-edit-info pa-sm-10 pa-3">
      <v-card-title class="justify-center text-h5">
        Klas toevoegen
      </v-card-title>
      <v-card-text class="text-center mt-n2">
        Aan welke klas wil je de leerkracht toegang verlenen?
      </v-card-text>

      <v-card-text class="mt-5">
        <v-form class="multi-col-validation">
          <v-row>
            <!-- Klas -->
            <v-col
              cols="12"
              sm="12"
            >
              <v-select
                v-model="formDataLocal.selectedClass"
                :items="classList"
                item-text="title"
                item-value="value"
                outlined
                dense
                label="Klas"
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              class="d-flex justify-center mt-3"
            >
              <v-btn
                color="primary"
                class="me-3"
                type="submit"
                @click.prevent="onSubmit"
              >
                Toegang verlenen
              </v-btn>

              <v-btn
                outlined
                color="secondary"
                @click.prevent="$emit('update:is-add-class-dialog-open',false)"
              >
                Annuleren
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '@axios'
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    isAddClassDialogOpen: {
      type: Boolean,
      required: true,
    },
    classList: {
      type: Array,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const formDataLocal = ref({
      selectedClass: null,
    })

    // on form submit
    const onSubmit = async () => {
      try {
        // Make sure a class was selected
        if (!formDataLocal.value.selectedClass) {
          throw new Error('Gelieve een klas te selecteren')
        }

        const school = JSON.parse(localStorage.getItem('school'))

        // Add class
        const added = await axios.post(`/school/${school.id}/teacher/${props.userData.id}/class`, {
          classId: formDataLocal.value.selectedClass,
        })
        console.log(added.data)
        if (!added.data.success) throw new Error('Could not add class')
      } catch (error) {
        // toast('error', 'Foutief wachtwoord', 'Probeer het opnieuw')
        console.log(error)
      } finally {
        emit('refetch-data')
        emit('update:is-add-class-dialog-open', false)
      }
    }

    watch(
      () => props.isAddClassDialogOpen,
      () => {
        formDataLocal.value = {
          selectedClass: null,
        }
      },
    )

    return {
      formDataLocal,
      onSubmit,
    }
  },
}
</script>
